import React from "react";
import styled from "styled-components";

import { StyledRow } from "../../../../../../../../../../components/common";

const TabButton = styled.button<{ $active: boolean }>`
	padding: 0;
	margin: 0;
	font-size: 14px;
	border: 1px solid transparent;
	border-bottom: none;
	border-radius: 6px 6px 0 0;
	box-shadow: ${({ $active }) =>
		$active ? "rgba(0, 0, 0, 0.15) 0px -1px 4px 0px" : "none"};
	background: ${({ $active }) => ($active ? "#fff" : "#ebebeb")};
	color: ${({ $active }) => ($active ? "#000" : "#666")};
	cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
	transition: background 0.2s ease;

	&:hover {
		background: ${({ $active, disabled }) => {
			if (disabled) return "inherit";
			return $active ? "#fff" : "#ebebeb";
		}};
	}
`;

function CustomTabs<T>({
	options,
	value,
	onChangeSelectedOption,
}: TabsProps<T>) {
	return (
		<StyledRow gap="1px" p="6px 8px 0px">
			{options.map((option) => {
				const isActive = option.value === value;

				return (
					<TabButton
						key={option.key}
						$active={isActive}
						disabled={option.disabled}
						onClick={() =>
							!option.disabled && onChangeSelectedOption?.(option)
						}
					>
						{option.label}
					</TabButton>
				);
			})}
		</StyledRow>
	);
}

export interface TabOption<T> {
	key: string;
	label: React.ReactNode;
	disabled?: boolean;
	value: T;
}

interface TabsProps<T> {
	options: TabOption<T>[];
	value: T;
	onChangeSelectedOption?: (option: TabOption<T>) => void;
}

export default CustomTabs;
